import React, { useState, useEffect, useRef } from "react";
import * as d3 from "d3";
import axios from "axios";
import PdmcUsecaseSidebar from "../Common/PdmcUsecaseSidebar";
import { Link } from "react-router-dom";
import Chart from "react-apexcharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faBarChart, faPieChart } from "@fortawesome/free-solid-svg-icons";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { TabPane } from "react-bootstrap";

const PdmcAnalyticA = () => {
  const svgRef = useRef();
  const [geoJsonData, setGeoJsonData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("India Map");
  const [popupContent, setPopupContent] = useState("");
  const [maxValue, setMaxValue] = useState("")

  const [stateCode, setStateCode] = useState("0");
  const [districtCode, setDistrictCode] = useState("0");
  const [subDistrictCode, setSubDistrictCode] = useState("0");
  const [villageCode, setVillageCode] = useState("0");

  const [stateArray, setStateArray] = useState([]);
  const [totalArea, setTotalArea] = useState([]);
  const [miArea, setMiArea] = useState([]);
  const [oiArea, setOiArea] = useState([]);

  const [pdmcData, setPdmcData] = useState([]);

  const [cropGroupData, setCropGroupData] = useState([]);
  const [cropNameData, setCropNameData] = useState([]);
  const [cropVarietyData, setCropVarietyData] = useState([])
  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [subDistrictData, setSubDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [villageData, setVillageData] = useState([]);

  const [yearValue, setYearValue] = useState("");
  const [cropGroupValue, setCropGroupValue] = useState("");
  const [cropNameValue, setCropNameValue] = useState("");
  const [cropVarietyValue, setCropVarietyValue] = useState("")
  const [stateValue, setStateValue] = useState("");
  const [districtValue, setDistrictValue] = useState("");
  const [subDistrictValue, setSubDistrictValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [villageValue, setVillageValue] = useState("");

  const [chartToggle, setChartToggle] = useState(true);

  const width = 500;
  const height = 600;

  useEffect(() => {
    fetchData("0", "0", "0");
    fetchPDMCData();
  }, []);

  useEffect(() => {
    const cropGroup = async () => {
      const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommCropGroup/getAllCropGroupExtList`);
      setCropGroupData(result.data.dataContent);
    };

    cropGroup();
  }, []);

  
  const cropName = async (value) => {
    setCropGroupValue(value);

    const result = await axios.post(
      `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommCrop/getCropExtList`,
      {
        cropGroupCode: value,
      }
    );
    setCropNameData(result.data.dataContent);
  };

  const cropVariety = async (value) => {
    setCropNameValue(value);
    const result = await axios.post(
      `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Management/CommCropVariety/getCropVarietyExtList`,
      {
        // "cropGroupCode": cropGroupValue,
        cropCode: value,
      }
    );
    setCropVarietyData(result.data.dataContent);
  };

  const fetchData = async (stateCode, districtCode, subDistrictCode) => {
    console.log("codes !!", stateCode, typeof(stateCode), districtCode, subDistrictCode);
    try {
      setLoading(true);
      const result = await axios.post(
        `https://km.amnex.co.in/appdevapi/api/Reverse/DashbodJson/GetGeoJson`,
        {
          StateCode: stateCode === "0" || stateCode === "reset"  ? "" :  stateCode,
          districtCode: districtCode === "0"  || stateCode === "reset" ? "" :   districtCode,
          SubDistrictCode: subDistrictCode === "0"  || stateCode === "reset" ? "" :  subDistrictCode,
        }
      );

      if (result && result.data && result.data.dataContent) {
        setGeoJsonData(result.data.dataContent);
      }
    } catch (error) {
      console.error("Error fetching GeoJSON data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchPDMCData = async (stateCode, districtCode, blockCode) => {
    try {
      const result = await axios.post(
        `${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/DashboardPdmc/GetPdmcDashboardAreaDetails`,
        {
          finYear: stateCode === "reset" ? "" : yearValue,
          cropGroupCode: stateCode === "reset" ? "" : cropGroupValue,
          cropNameCode: stateCode === "reset" ? "" : cropNameValue,
          stateLgdCode: stateCode === "0" || stateCode === "reset" ? "" : stateCode,
          districtLgdCode: districtCode === "0" || stateCode === "reset" ? "" : districtCode,
          blockLgdCode: blockCode === "0" || stateCode === "reset" ? "" : blockCode,
          villageLgdCode: "",
        }
      );
      let stateArrayLocal = [];
      let totalAreaLocal = [];
      let miAreaLocal = [];
      let oiAreaLocal = [];

      if (result) {
        setPdmcData(result.data.dataContent);
        let maxValueLocal = 0;
        result.data.dataContent.map((item, index) => {
          if(item.villageName != "") {
            stateArrayLocal.push(item.villageName);
          } else if(item.subDistrictName != ""){
            stateArrayLocal.push(item.subDistrictName);
          } else if(item.districtName != "") {
            stateArrayLocal.push(item.districtName);
          } else if(item.stateName != "") {
            stateArrayLocal.push(item.stateName);
          }
        
          totalAreaLocal.push(item.areas.totalArea);
          miAreaLocal.push(item.areas.mi);
          oiAreaLocal.push(item.areas.oi);

          const value = item.areas.totalArea; 
    if (value > maxValueLocal) {
      maxValueLocal = value;
    }

        });
        console.log("maxValueLocal", maxValueLocal)
        setMaxValue(maxValueLocal);
      }
      setStateArray(stateArrayLocal);
      setTotalArea(totalAreaLocal);
      setMiArea(miAreaLocal);
      setOiArea(oiAreaLocal);
    } catch (error) {
      console.error("Error fetching population data:", error);
    }
  };

  const handleSvgClick = (event, properties) => {
    const localStateCode = properties.properties.state_LGD.toString();
    const localDistrictCode = properties.properties.dist_LGD.toString();
    const localSubDistrictCode = properties.properties.subdt_LGD.toString();
    fetchData(localStateCode, localDistrictCode, localSubDistrictCode);
    fetchPDMCData(localStateCode, localDistrictCode, localSubDistrictCode);
    handleMouseOut();
  };

  // ... (previous code)

  const handleFeatureHover = (event, properties, tooltip) => {
    console.log("properties", properties, event, tooltip);
    // Show tooltip on hover
    tooltip.transition().duration(200).style("opacity", 0.9);
    let textValue = "";

    if (properties.id) {
      textValue = properties.id;
      if (document.getElementById("first")) {
        document.getElementById("first").style.marginTop = "-200 px";
      }
    } else if (properties.properties.Dist_Name) {
      textValue = properties.properties.Dist_Name;
    } else {
      textValue = properties.properties.SUB_DIST;
    }

    // Position the tooltip
    tooltip
      .html(`<strong id="first">Properties:</strong><br>${textValue}`)
      .style("left", `${event.pageX}px`)
      .style("top", `-400 px`);
    // .style('margin-top', '-200px')
  };

  // ... (rest of the code)

  useEffect(() => {
    renderGeoJSON();
  }, [geoJsonData]);

  const renderGeoJSON = () => {
    const svg = d3.select(svgRef.current);
    svg.selectAll("*").remove(); // Clear existing elements

    const projection = d3.geoMercator().fitSize([width, height], {
      type: "FeatureCollection",
      features: geoJsonData,
    });

    const pathGenerator = d3.geoPath().projection(projection);
    // const colorScale = d3.scaleOrdinal(d3.schemeCategory10);

    // function colorScale() {
    //   let arr = ["#3b9ad7", "#d89ca3", "#d8816c", "#c5c5ec", "#a78a6b", "#739666", "#85b58c", "#99d0cd", "#85c56f", "#5badda", "#d04db5", "#f2c899", "#aadeff", "#859b9f", "#686a6e", "#ae7335", "#8ad7bd", "#ffbb4f", "#c43f7c", "#eb6071", "#ed9de1", "#80de86", "#e1a4ba", "#1b70bc", "#41cae5", "#6deae0", "#de797b", "#ebc04f"];
    
    //   return   arr[(Math.floor(Math.random() * arr.length))]
    // }

    // var buckets = 4,
    //  colors = ["#edf8b1", "#7fcdbb", "#41b6c4", "#1d91c0"]; // alternatively  
    // // colors = ["#aedeab", "#74bf6f", "#43b83d", "#279421"]

    var buckets = 5,
    colors = [ "#e9ebf7", "#72ccdb", "#1d91c0", "#225ea8", "#253494"]; // alternatively colorbrewer.YlGnBu[9]
    
    // const colorScale = d3.scaleLinear()
    // .domain([0, Number(maxValue)]) // Adjust maxValue according to your data
    // .range(["#E9F7EF", "#52BE80", "#196F3D", "#145A32"]); // Define the color range from low to high

    var colorScale = d3.scaleLinear()
    .domain(d3.range(buckets).map(function (d) { return (d / buckets) * maxValue }))
    .range(colors);


    const tooltip = d3
      .select("body")
      .append("div")
      .attr("class", "tooltip")
      .style("opacity", 0);

    let mouseOver = function (d) {
      d3.selectAll(".Country").transition().duration(200).style("opacity", 0.5);
      d3.select(this)
        .transition()
        .duration(200)
        .style("opacity", 1)
        .style("stroke", "black");
    };

    let mouseLeave = function (d) {
      d3.selectAll(".Country").transition().duration(200).style("opacity", 0.8);
      d3.select(this).transition().duration(200).style("stroke", "transparent");
    };

    svg
      .selectAll("path")
      .data(geoJsonData)
      .enter()
      .append("path")
      .attr("d", pathGenerator)
      .attr("fill", (feature, index) => {
        // Retrieve the data value for each feature
        // const dataValue = getDataValue(feature); // Implement this function to get the data value for each feature
      
        let labelName = "";
        let recordCount = {};
  
        if (feature.properties.villageName != "") {
          recordCount = getPDMCDataByStateCode(
            feature.properties.village_LGD,
            "village"
          );
          labelName = feature.properties.villageName;
        } else if (feature.properties.sdtname != "") {
          recordCount = getPDMCDataByStateCode(
            feature.properties.subdt_LGD,
            "subDistrict"
          );
          labelName = feature.properties.sdtname;
        } else if (feature.properties.dtname != "") {
          recordCount = getPDMCDataByStateCode(
            feature.properties.dist_LGD,
            "district"
          );
          labelName = feature.properties.dtname;
        } else {
          recordCount = getPDMCDataByStateCode(
            feature.properties.state_LGD,
            "state"
          );
          labelName = feature.properties.stname;
        }
        console.log('recordCount', recordCount)

        if(recordCount === "0") {
          console.log("inside if", recordCount, typeof(recordCount))
          return "#FFFFFF"
        }else {
          console.log("inside else", recordCount, typeof(recordCount))
          return colorScale(recordCount.areas.totalArea)
        }

        // return colorScale(recordCount != "0" ? recordCount.areas.totalArea : 0)
  
       
      })
      
      .attr("stroke", "#2a2a2a")
      .attr("stroke-width", "0.5")
      .on("click", (event, feature) => handleSvgClick(event, feature))
      .on("mouseover", (event, feature) => handleMouseOver(event, feature))
      .on("mouseout", handleMouseOut);
    //       .on("mouseover", function(d) {
    //         console.log("d",d)
    //         d3.select("#tooltip").transition()
    //            .duration(200)
    //            .style("opacity", .9);
    //         d3.select("#tooltip").html("<h3>hello</h3>")
    //            .style("left", "658px")
    //            .style("top", "213px");
    //  })
    //  .on("mouseout", function(d) {
    //         d3.select("#tooltip").transition()
    //            .duration(500)
    //            .style("opacity", 0);
    //  });
    // .on("mouseover", mouseOver )
    // .on("mouseleave", mouseLeave )
    // .on('mouseover', (event, feature) => handleMouseOver(event, feature));
    // .on("mouseover", (event, features) =>
    //     handleFeatureHover(event, features, tooltip)
    //   )
    // .on('mouseout', handleMouseOut);

    svg
      .selectAll("text")
      .data(geoJsonData)
      .enter()
      .append("text")
      .attr("x", (d) => pathGenerator.centroid(d)[0])
      .attr("y", (d) => pathGenerator.centroid(d)[1])
      .attr("text-anchor", "middle")
      .attr("dy", "0.5em")
      .style("font-size", "10px")
      .style("fill", "black")
      .text((d) => {
        // Customize text content based on conditions
        if (d.properties.villageName != "") {
          setStateCode(d.properties.state_LGD);
          setDistrictCode(d.properties.dist_LGD);
          // setSubDistrictCode(d.properties.subdt_LGD)
          console.log(
            "setSubDistrictCode",
            d.properties.state_LGD,
            d.properties.dist_LGD,
            d.properties.subdt_LGD
          );
          return d.properties.villageName;
        } else if (d.properties.sdtname != "") {
          setStateCode(d.properties.state_LGD);
          setDistrictCode("0");

          console.log(
            "setDistrictCode",
            d.properties.state_LGD,
            d.properties.dist_LGD
          );

          return d.properties.sdtname;
        } else if (d.properties.dtname != "") {
          setStateCode("0");

          console.log("setStateCode", d.properties.state_LGD);

          return d.properties.dtname;
        } else {
          // Default to the state name
          // let filtered = pdmcData.filter(row => row.stateCode === d.properties.state_LGD);
          // console.log("filtered", filtered);

          const recordCount = getPDMCDataByStateCode(d.properties.state_LGD);

          return d.properties.stname;
        }
      })
      .on("mouseover", (event, feature) => handleMouseOver(event, feature))
      .on("mouseout", handleMouseOut);

    function handleMouseOver(event, feature) {
      // console.log("d$$", d)
      // const x = d.pageX + 10;
      // const y = d.pageY - 10;
      // // Display a popup with the feature name
      // // const popupText = d.properties.name; // Adjust based on your data
      // svg.append("text")
      //   .attr("class", "popup-text")
      //   .attr("x", x)
      //   .attr("y", y)
      //   .style("fill", "purple")
      //   .attr("text-anchor", "middle")
      //   .text("popupText")
      //   .style("font-size", "20px")

      let labelName = "";
      let recordCount = {};

      if (feature.properties.villageName != "") {
        recordCount = getPDMCDataByStateCode(
          feature.properties.village_LGD,
          "village"
        );
        labelName = feature.properties.villageName;
      } else if (feature.properties.sdtname != "") {
        recordCount = getPDMCDataByStateCode(
          feature.properties.subdt_LGD,
          "subDistrict"
        );
        labelName = feature.properties.sdtname;
      } else if (feature.properties.dtname != "") {
        recordCount = getPDMCDataByStateCode(
          feature.properties.dist_LGD,
          "district"
        );
        labelName = feature.properties.dtname;
      } else {
        recordCount = getPDMCDataByStateCode(
          feature.properties.state_LGD,
          "state"
        );
        labelName = feature.properties.stname;
      }

      // const recordCount = getPDMCDataByStateCode(feature.properties.state_LGD);
      // console.log("recordCount", recordCount)

      let innerHTML = `<h3 id="heading">${labelName}</h3><p>Total No of Farmers Covered: ${
        recordCount === "0" ? "0" : recordCount.totalFarmer
      } </p><p>Total Area covered Under PDMC: ${
        recordCount === "0" ? "0" : recordCount.areas.totalArea
      } (Acre) </p><p>Area covered via Micro irrigation: ${
        recordCount === "0" ? "0" : recordCount.areas.mi
      } (Acre) </p><p>Area covered via Other Interventions: ${
        recordCount === "0" ? "0" : recordCount.areas.oi
      } (Acre)</p>`;
      document.getElementById("popupContent").innerHTML = innerHTML;

      console.log("innerHTML", innerHTML);

      // Object.assign(elPopup.style, {
      //   left: `${event.pageX}px`,
      //   top:  `${event.pageY}px`,
      //   display: `block`,
      // });

      document.getElementById("popup").style.display = "block";
      document.getElementById("popup").style.left = `250px`;
      document.getElementById("popup").style.top = `100px`;
    }

    // Define mouseout event handler
  };

  // "subdt_LGD": 0,
  // "dist_LGD": 96,
  // "state_LGD": 8,
  // "village_LGD": "0",

  const getPDMCDataByStateCode = (placeCode, key) => {
    let keyCode = "";

    let PDMCRecord = {};

    if (key === "village") {
      console.log("village", placeCode, placeCode, pdmcData);
      PDMCRecord = pdmcData.find(
        (record) => record.villageCode === Number(placeCode)
      );
      console.log("PDMCRecord", PDMCRecord);
    } else if (key === "subDistrict") {
      PDMCRecord = pdmcData.find(
        (record) => record.subDistrictCode === placeCode
      );
    } else if (key === "district") {
      PDMCRecord = pdmcData.find((record) => record.districtCode === placeCode);
    } else {
      PDMCRecord = pdmcData.find((record) => record.stateCode === placeCode);
    }

    return PDMCRecord ? PDMCRecord : "0";
  };
  function handleMouseOut() {
    // Remove the popup text
    // svg.select(".popup-text").remove();

    document.getElementById("popup").style.display = "none";
  }

  function handleBackBtn() {
    fetchData(String(stateCode), String(districtCode), String(subDistrictCode));
    fetchPDMCData(
      String(stateCode),
      String(districtCode),
      String(subDistrictCode)
    );
    handleMouseOut();
  }

  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/states`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function handleState(value) {
    setStateValue(value);
    if (value === "NA") {
      return;
    }
    setDistrictData([]);
    setDistrictValue("");
    // setSubDistrictValue("");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/district`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleSubDistrict(value, DDValue) {
    setDistrictValue(value);

    if (value === "NA") {
      return;
    }
    if (value != null) {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: value,
      });
    } else {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: districtValue,
      });
    }

    // setSubDistrictValue(value);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/subdistrict`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }
  function handleBlock(value) {
    setDistrictValue(value);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      // subdistrictcode: value,
      districtcode: value,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/block`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setBlockData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleVillage(value) {
    // setSubDistrictValue(value);
    console.log("block code", blockValue);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      blockcode: blockValue,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/village`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setVillageData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  const seriesAC2 = [
    {
      name: "Other Intervention",
      data: oiArea,
    },
    {
      name: "Micro Irrigation",
      data: miArea,
    },
    {
      name: "Total",
      data: totalArea,
    },
  ];

  const optionsAC2 = {
    chart: {
      type: "bar",
      height: 430,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetX: -6,
      style: {
        fontSize: "12px",
        colors: ["#fff"],
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["#fff"],
    },
    tooltip: {
      shared: true,
      intersect: false,
    },
    xaxis: {
      categories: stateArray,
    },
  };

  function handleReset() {
    setStateValue("");
    setDistrictValue("");
    setSubDistrictValue("");
    setBlockValue("");
    setVillageValue("");
    setYearValue("");
    setCropGroupValue("");
    setCropNameValue("");
    setCropVarietyValue("")

    // setYearValue("");
    // setSeasonValue("");
    // setCropGroupValue("");
    // setCropNameValue("");
    // setCropVarietyValue("");

    fetchData("reset");
    fetchPDMCData("reset")
  }


  function handleFilterCall () {
    fetchData(stateValue, districtValue, blockValue)
    fetchPDMCData(stateValue, districtValue, blockValue)

  }

  const seriesAC1Pie = totalArea;

  const optionsAC1Pie = {
    chart: {
      height: 300,
      type: "pie",
    },
    labels: stateArray,
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: true,
      position: "bottom",
    },
  };

  const seriesAC2Pie = miArea;

  const optionsAC2Pie = {
    chart: {
      height: 300,
      type: "pie",
    },
    labels: stateArray,
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: true,
      position: "bottom",
    },
  };
  const seriesAC3Pie = oiArea;

  const optionsAC3Pie = {
    chart: {
      height: 300,
      type: "pie",
    },
    labels: stateArray,
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: true,
      position: "bottom",
    },
  };

  function handleToggleChart() {
    let toggle = !chartToggle
    setChartToggle(toggle)
  }
  return (
    <>
      <PdmcUsecaseSidebar />
      <div className="page-wrapper chiller-theme toggled ">
        <main id="main" className="main pdmcanalyticinner pdmcanalyticsdashboardss">
          <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
            <nav>
              <h5 className="mb-0 text-white">Per Drop More Crop (PDMC) Dashboard </h5>
              {/* <ol className="breadcrumb">
                <li className="breadcrumb-item">Admin</li>
                <li className="breadcrumb-item active">PDMC Usecase I</li>
              </ol> */}
            </nav>
            <Link className="btn btn-success btn-sm" to="/Analytics">
              Back
            </Link>
          </div>
          <div className="card pdmcreportss_card">
            <div className="card-body onbordedSchemess schemesreport pdmcreportss">
             
              <div className="row">
              <div className="col-md-2">
                        <label htmlFor="year" className="form-label">
                          Financial Year
                        </label>
                        <select
                          className="form-select"
                          onChange={(e) => setYearValue(e.target.value)}
                          value = {yearValue}
                        >
                          <option defaultValue>Choose...</option>
                          <option value="2021-2022">2021-2022</option>
                          <option value="2022-2023">2022-2023</option>
                          <option value="2023-2024">2023-2024</option>
                        </select>
                      </div>         

                      <div className="col-md-2">
                        <label htmlFor="cropGroup" className="form-label">
                          Crop Group
                        </label>
                        <select
                          id="cropGroup"
                          required
                          className="form-select"
                          // onClick={cropName}
                          onChange={(e) => cropName(e.target.value)}
                          value={cropGroupValue}
                        >
                          <option defaultValue>Choose...</option>
                          {cropGroupData
                            ? cropGroupData.map((item, id) => {
                                return (
                                  <option key={id} value={item.cropGroupCode}>
                                    {" "}
                                    {item.cropGroupName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label htmlFor="cropName" className="form-label">
                          Crop Name
                        </label>
                        <select
                          id="cropName"
                          required
                          className="form-select"
                          // onClick={getDesignation}
                          onChange={(e) => cropVariety(e.target.value)}
                          value={cropNameValue}
                        >
                          <option defaultValue>Choose...</option>
                          {cropNameData
                            ? cropNameData.map((item, id) => {
                                return (
                                  <option key={id} value={item.cropCode}>
                                    {" "}
                                    {item.cropName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>

                      <div className="col-md-2">
                        <label htmlFor="cropVariety" className="form-label">
                          Crop Varietry
                        </label>
                        <select
                          id="cropVarietry"
                          required
                          className="form-select"
                          // onClick={getDesignation}
                          onChange={(e) => setCropVarietyValue(e.target.value)}
                          value={cropVarietyValue}
                        >
                          <option defaultValue>Choose...</option>
                          {cropVarietyData
                            ? cropVarietyData.map((item, id) => {
                                return (
                                  <option key={id} value={item.cropVarietyCode}>
                                    {" "}
                                    {item.cropVarietyName}
                                  </option>
                                );
                              })
                            : ""}
                        </select>
                      </div>
                <div className="col-md-2">
                  <label htmlFor="State" className="form-label" id="StateLabel">
                    State
                  </label>
                  <select
                    id="State"
                    required
                    className="form-select"
                    onClick={getStates}
                    onChange={(e) => handleState(e.target.value)}
                    value={stateValue}
                    name="stateCode"
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {statesData
                      ? statesData.map((item, id) => {
                          return (
                            <option key={id} value={item.stateCode}>
                              {" "}
                              {item.stateName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2">
                  <label
                    htmlFor="District"
                    className="form-label"
                    id="DistrictLabel"
                  >
                    District
                  </label>
                  <select
                    id="District"
                    className="form-select"
                    onChange={(e) => handleBlock(e.target.value)}
                    value={districtValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>

                    {districtData
                      ? districtData.map((item, id) => {
                          return (
                            <option key={id} value={item.districtCode}>
                              {" "}
                              {item.districtName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                {/* <div className="col-md-2">
                        <label
                          htmlFor="subDistrict"
                          className="form-label"
                          id="subDistrictLabel"
                        >
                          SubDistrict
                        </label>
                        <select
                          id="subDistrict"
                          className="form-select"
                          onChange={(e) => handleBlock(e.target.value)}
                          value={subDistrictValue}
                        >
                          <option defaultValue value="NA">
                            Choose...
                          </option>

                          {subDistrictData.map((item, id) => {
                            return (
                              <option key={id} value={item.subDistrictCode}>
                                {" "}
                                {item.subDistrictName}
                              </option>
                            );
                          })}
                        </select>
                      </div> */}
                <div className="col-md-2">
                  <label htmlFor="Block" className="form-label" id="BlockLabel">
                    Block
                  </label>
                  <select
                    id="Block"
                    className="form-select"
                    onClick={handleVillage}
                    onChange={(e) => setBlockValue(e.target.value)}
                    value={blockValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {blockData
                      ? blockData.map((item, id) => {
                          return (
                            <option key={id} value={item.blockCode}>
                              {" "}
                              {item.blockName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2">
                  <label htmlFor="inputVillage" className="form-label">
                    Village
                  </label>
                  <select
                    id="Village"
                    className="form-select"
                    // onClick={handleVillage}
                    onChange={(e) => setVillageValue(e.target.value)}
                    value={villageValue}
                  >
                    <option defaultValue value="NA">
                      Choose...
                    </option>
                    {villageData
                      ? villageData.map((item, id) => {
                          return (
                            <option key={id} value={item.villageCode}>
                              {" "}
                              {item.villageName}
                            </option>
                          );
                        })
                      : ""}
                  </select>
                </div>
                <div className="col-md-2 mt-4 filterbtn">
                  <button
                    type="submit"
                    className="btn btn-submit btn-success"
                    onClick={handleFilterCall}
                  >
                    Filter
                  </button>{" "}
                  &nbsp;
                  <button
                    type="submit"
                    className="btn btn-outline-secondary"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                </div>
              </div>
           
            </div>
          </div>
          <div className="card">
            <div className="card-body onbordedSchemess schemesreport pdmcanalyticsclasses">
            <h3 className="mb-2">CROP-WISE AND STATE-WISE AREA IRRIGATED</h3>
              <div className="row">
                <div className="col-md-6">
                  {loading === false ? (
                    <>
                      <div id="popup">
                        <div class="popup-container">
                          <div class="popup" id="popupContent"></div>
                        </div>
                      </div>
                      <button
                        className="btn btn-outline-success btn-sm btnlefts"
                        onClick={() => handleBackBtn()}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} />{" "}
                      </button>
                      <svg ref={svgRef} width={width} height={height}></svg>
                    </>
                  ) : (
                    <div class="overlay">
                      <div class="overlay__inner">
                        <div class="overlay__content">
                          <span class="spinner"></span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <button
                    type="text"
                    className="btn btn-outline-success btn-sm btnrights"
                    onClick={() => handleToggleChart()}
                  >
                    <FontAwesomeIcon icon={chartToggle ? faBarChart : faPieChart} />{" "}
                  </button>

                  {
                    chartToggle ?   <Tabs>
                    <TabList>
                      
                      <Tab>Micro Irrigation</Tab>
                      <Tab>Other Intervention</Tab>
                      <Tab>Total</Tab>
                    </TabList>   
                    <TabPanel>
                      <strong className="pull-right">Area in hactare</strong>
                    {seriesAC2Pie != [] ? <>  <Chart type="pie" series={seriesAC2Pie} options={optionsAC2Pie} height={450}/></> : ""}
                    </TabPanel>
                    <TabPanel>
                    {seriesAC3Pie != [] ? <> <Chart type="pie" series={seriesAC3Pie} options={optionsAC3Pie} height={450}/></> :""}
                    </TabPanel>
                    <TabPanel>
                    {seriesAC1Pie != [] ? <><Chart type="pie" series={seriesAC1Pie} options={optionsAC1Pie} height={450}/> </>: ""} 
                    </TabPanel>
                  </Tabs> : <div>
                  <div id="chart">
                    <Chart
                      type="bar"
                      series={seriesAC2}
                      options={optionsAC2}
                      height={600}
                    />
                  </div>
                 
             
  </div>
                  }
                
            </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default PdmcAnalyticA;
